var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 765,
    height: 703,
    viewBox: "0 0 765 703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5vliznd8dc",
    x1: -0.007,
    x2: 1.051,
    y1: 0.013,
    y2: 0.536,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0e4p6xdvha"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0H765V703H0z",
    transform: "translate(0 795)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d88r4fqfnb",
    width: 905,
    height: 814,
    x: -120,
    y: -58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0096f2",
    floodOpacity: 0.345
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0e4p6xdvha)",
    transform: "translate(0 -795)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d88r4fqfnb)",
    transform: "matrix(1, 0, 0, 1, 0, 795)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#5vliznd8dc)",
    d: "M0 344.471C225.979 320.439 313.052 594.4 487.217 572.784c116.195-14.42 266.046-180.247 112.188-374.913S0 0 0 0z",
    transform: "translate(0 51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg2.aa20fcf0fea85b979c5fa1cd34b01113.svg";
export { ForwardRef as ReactComponent };